export class nagesConfig {
    API_PATH = "https://nages.solinges.com.ar:444";
}